/**
 * JS pro show-more efekt.
 * Je třeba zachovat základní html strukturu.
 * <div class="show-more-cont">
 * <div class="show-more-text">Obsah</div>
 * <span class="show-more">Zobrazit více</span>
 * <span class="show-less">Zobrazit méně</span> //V případě, že má jít obsah po rozbalení skrýt
 * </div>
 * Je třeba dostylovat dle potřeby!!! Show-more se zobrazí, pokud je vykreslená výška show-more-text menší, než reálná.
 */

function initShowMoreCont(element) {
	if (element === undefined) {
		return false;
	}
	let showMoreConts = element.querySelectorAll('.show-more-cont');

	if (showMoreConts.length === 0) {
		return false;
	}

	showMoreConts.forEach(function (showMoreCont) {
		let content = showMoreCont.querySelector('.show-more-text');
		let showMoreButton = showMoreCont.querySelector('.show-more');
		let showLessButton = showMoreCont.querySelector('.show-less');

		showMoreButton.addEventListener('click', function () {
			content.style.height = 'auto';
			content.classList.remove('hidden');
			showMoreButton.classList.add('hidden');
		});

		showLessButton?.addEventListener('click', function () {
			content.style.removeProperty('height');
			content.classList.add('hidden');
			showMoreButton.classList.remove('hidden');

			showMoreButton.scrollIntoView({ behavior: 'smooth', block: 'center' });
		});

		if (content.scrollHeight > content.clientHeight) {
			showMoreButton.classList.remove('hidden');
		}
	});
}

/**
 * JS pro zobrazit/skrýt zaškrtnuté checkboxy
 * Musí to mít tuto strukturu
 *
 * <div class="show-check-uncheck">
 *  	<div n:foreach="$form[radio]->getItems() as $key => $label" class="show-check-uncheck-item"
 * 				n:attr="hidden => !in_array($key, $form[radio]->getValue())">
 * 			<label class="form-check-label d-flex gap-2">
 * 				<input class="form-check-input"> {$label}
 * 			</label>
 * 		</div>
 *
 * 		<span class="hide-uncheck fw-medium text-red" n:attr="hidden => count($form[radio]->getValue()) <= count($form[radio]->getItems())">Skrýt neoznačené soubory</span>
 * 		<span class="show-uncheck fw-medium text-red" n:attr="hidden => count($form[radio]->getValue()) === count($form[radio]->getItems())">Zobrazit všechny uložené soubory</span>
 * 	</div>
 */

function initShowMoreContChecUncheck(element) {
	let showMoreBlocks = element.querySelectorAll('.show-check-uncheck');

	showMoreBlocks.forEach(function (showMore) {
		let items = showMore.querySelectorAll('.show-check-uncheck-item');
		let showMoreButton = showMore.querySelector('.show-uncheck');
		let showLessButton = showMore.querySelector('.hide-uncheck');

		// Obsluha při přepínání checkboxů
		items.forEach((item) => {
			item.querySelector('input')?.addEventListener('change', (e) => {
				let countChecked = Array.from(showMore.querySelectorAll('.show-check-uncheck-item input')).filter(
					(input) => input.checked
				).length;

				let countAll = items.length;

				// máme-li zobrazeno vše a vše je zakliknuto, tak skryjeme obě tlačítka zobrazit/skrýt
				if (countAll === countChecked) {
					showLessButton.setAttribute('hidden', '');
					showMoreButton.setAttribute('hidden', '');

					return;
				}

				let countCheckedVisible = Array.from(
					showMore.querySelectorAll('.show-check-uncheck-item:not([hidden]) input')
				).filter((input) => input.checked).length;

				let countAllVisible = Array.from(
					showMore.querySelectorAll('.show-check-uncheck-item:not([hidden])')
				).length;

				// máme-li zakliknuto to co je zobrazeno, tak skryjeme tlačítko "skrýt" a zobrazíme "zobrazit více"
				if (countAllVisible === countCheckedVisible) {
					showLessButton.setAttribute('hidden', '');
					showMoreButton.removeAttribute('hidden');
				} else if (countAllVisible === countAll) {
					// máme-li zobrazeny všechny položky a nespadlo nám to do předchozích podmínek, tak zobrazíme tlačítko "skrýt"
					showLessButton.removeAttribute('hidden');
				}
			});
		});

		// Zobrazení všech
		showMoreButton.addEventListener('click', function () {
			items.forEach((item) => item.removeAttribute('hidden'));

			showMoreButton.setAttribute('hidden', '');
			showLessButton.removeAttribute('hidden');
		});

		// Skrytí těch co nemají zaškrtnutý checkbox
		showLessButton.addEventListener('click', function () {
			items.forEach((item) => {
				if (!item.querySelector('input')?.checked) {
					item.setAttribute('hidden', '');
				}
			});

			showLessButton.setAttribute('hidden', '');
			showMoreButton.removeAttribute('hidden');
		});
	});
}

export default function () {
	$.nette.ext('show-more', {
		init: function () {
			initShowMoreCont(document);
			initShowMoreContChecUncheck(document);


			this.ext('snippets', true).after(($el) => {
				if ($el.get(0)) {
					initShowMoreCont($el.get(0));
					initShowMoreContChecUncheck($el.get(0));
				}
			});
		}
	});
}
